import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import theme from '../../constants/AppTheme';

export const Text = styled.div`
  color: ${({ color }) => color || theme.black};
  font-size: ${({ size }) => (size ? `${size}px` : '14px')};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  text-transform: ${({ transform }) => (transform ? 'uppercase' : 'none')};
  ${({ p }) => (p ? 'display: block;' : '')}

  &:hover {
    opacity: ${({ opacity }) => (opacity ? '0.5' : 'none')};
  }
`;

function Txt({ children, color, bold, p, style, href, size, hover, opacity, ...props }) {
  if (href) {
    return (
      <Link to={href}>
        <Text
          p={p}
          style={style}
          bold={bold}
          size={size}
          color={color}
          opacity={opacity}
          {...props}>
          {children}
        </Text>
      </Link>
    );
  }

  return (
    <Text p={p} style={style} bold={bold} size={size} color={color} {...props}>
      {children}
    </Text>
  );
}

export default Txt;
